import React, { Component } from 'react'
import PublicCatalogLayout from '../layouts/PublicCatalogLayout'
import Cookies from 'universal-cookie'
import OrderDropdown from './partials/OrderDropdown';
import OrdersTable from './OrdersTable';
import { Button } from '@mui/material';
import { isJaguar } from '@/utility/UserUtils';
const OrdersDashboard = (props) => {
  const {user, renter} = props 
  const [ archived, setArchived ] = React.useState(false);
  const renderLinks = () => {
    const linkClasses="text-[#3070E7] text-base font-normal"
    return (
      <div className={`pb-[20px] ${linkClasses}`}>
        <a href="/reports/orders" target="_blank" > Download Order Report </a>
        {" | "}
        <a href="#" onClick={() => setArchived(!archived)}> View {archived ? "Active" : "Archived"} Orders</a>
      </div>
    );
  }

  return (
    <PublicCatalogLayout
      {...props}
      groups={[]}
      currentPage="orders_index"
      classNames={{body: 'white-background', container: 'full-width-container'}}
    >
      
      <div>
        <h1 class="catalog-h1">
          {archived ? "Archived " : ""}Orders{user.role == "client" && renter && ` by ${renter.name}`}
                        <div
                className="catalog-h1-float-right"
              >
                <Button variant="contained" color="green" href="/orders/new">Create New Order</Button>
              </div>
        </h1>
        {renderLinks()}
        <OrdersTable 
          {...props}
          archived={archived}
        />
 
      </div>
    </PublicCatalogLayout>
  )
}

export default OrdersDashboard
